import usePageTitle from "@/hooks/use-page-title";

export default function Terms() {
  usePageTitle("Terms & Conditions");
  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-8 py-16">
      <div className="overline mb-2">Legal</div>
      <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter mb-8">Terms &amp; Conditions</h1>
      <div className="space-y-6 text-zinc-700 text-sm leading-relaxed">
        <p><strong>Effective from:</strong> {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">1. Acceptance</h2>
          <p>By placing an order with Brothers Advertising (a unit of J U ENTERPRISES) you agree to these terms and conditions in full.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">2. Quotations &amp; Pricing</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>All quotations are valid for 30 days from the date of issue unless stated otherwise.</li>
            <li>Prices are exclusive of GST unless the quotation explicitly says "GST included".</li>
            <li>Any change in specifications (size, material, quantity) may result in a revised quotation.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">3. Orders &amp; Advance</h2>
          <p>Orders are considered confirmed only after a written confirmation and a minimum 50% advance payment. Custom / large-format orders may require 100% advance.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">4. Artwork &amp; Approval</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Customer is responsible for the accuracy of artwork, spellings, colours and specifications provided.</li>
            <li>Once a design proof is approved (via WhatsApp, email or portal), no reprints will be entertained free of cost.</li>
            <li>Files should be supplied in print-ready CMYK, 300 DPI where possible.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">5. Delivery</h2>
          <p>Delivery timelines shared are indicative and depend on artwork approval and payment realisation. Brothers Advertising is not liable for delays caused by force majeure, courier partners or client-side approvals.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">6. Payment Terms</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Balance payment is due at the time of dispatch or delivery.</li>
            <li>Delayed payments beyond 15 days may attract interest at 18% p.a.</li>
            <li>Cheques dishonoured will attract bank charges plus ₹500 admin fee.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">7. Cancellation &amp; Refund</h2>
          <p>Once an order enters printing, cancellation is not possible and no refund of advance will be made. Orders cancelled before printing are refundable after deducting any design / material cost already incurred.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">8. Warranty</h2>
          <p>Signage installations carry a 6-month workmanship warranty from the date of installation. Damage caused by weather, tampering or third-party modification is not covered.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">9. Jurisdiction</h2>
          <p>All disputes shall be subject to the exclusive jurisdiction of courts in Navi Mumbai, Maharashtra, India.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">10. Contact</h2>
          <p>Brothers Advertising (a unit of J U ENTERPRISES) · Taloja, Navi Mumbai · Customer Care: 022 4742 7059 · Mobile: +91 80709 70980 · print@brothersdigital.in</p>
        </div>
      </div>
    </div>
  );
}
